import React from "react";

/* A live heart-monitor line that scrolls continuously behind the hero.
   One 900px tile holds 4 ECG beats; several tiles scroll seamlessly. */

const BEAT = "h44 q10,-16 20,0 h16 l6,7 l6,-70 l7,86 l6,-23 h14 q14,-18 28,0 h78";
const PATH = `M0,90 ${BEAT} ${BEAT} ${BEAT} ${BEAT}`;

function Tile({ i }) {
  const gid = `ecgG${i}`;
  return (
    <svg className="ecg-svg" width="900" height="180" viewBox="0 0 900 180" aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#1C6EB4" />
          <stop offset="55%" stopColor="#3F9E72" />
          <stop offset="100%" stopColor="#1C6EB4" />
        </linearGradient>
      </defs>
      <path d={PATH} fill="none" stroke={`url(#${gid})`} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function EcgBackline() {
  return (
    <div className="ecg-wrap" aria-hidden="true">
      <div className="ecg-track">
        {Array.from({ length: 6 }).map((_, i) => (
          <Tile key={i} i={i} />
        ))}
      </div>
    </div>
  );
}
